import { addToCartAnimationListener } from "./store-filter";

const container = document.querySelector(".content.content--hidden");
const children = container.children;

if (children.length < 3) {
    container.querySelector(".button-wrapper").style.display = "none";
}

document.querySelector(".show-content").addEventListener("click", (e) => {
    e.srcElement.parentNode.parentNode.classList.toggle("content--hidden");
});

const plus = document.querySelector(".button-plus");
if (plus) {
    plus.addEventListener("click", () => {
        let value = parseInt(document.querySelector(".quantity-input-field").value);
        if (!value) {
            value = 0;
        }
        value++;
        document.querySelector(".quantity-input-field").value = value;
        updateCartButton();
    });
}

const minus = document.querySelector(".button-minus");
if (minus) {
    minus.addEventListener("click", () => {
        let value = parseInt(document.querySelector(".quantity-input-field").value);
        if (!value) {
            value = 2;
        }
        if (value > 1) {
            value--;
            document.querySelector(".quantity-input-field").value = value;
            updateCartButton();
        }
    });
}

const updateCartButton = () => {
    let value = parseInt(quantityInputField.value);
    const button = document.querySelector(".summary .flex-row-wrapper .add_to_cart_button");

    button.setAttribute("data-quantity", value);
};

const quantityInputField = document.querySelector(".quantity-input-field");
if (quantityInputField) {
    quantityInputField.addEventListener("input", updateCartButton);
}

addToCartAnimationListener();
